import { render, staticRenderFns } from "./Top.vue?vue&type=template&id=79ff80a2&scoped=true&"
import script from "./Top.vue?vue&type=script&lang=ts&"
export * from "./Top.vue?vue&type=script&lang=ts&"
import style0 from "./Top.vue?vue&type=style&index=0&id=79ff80a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ff80a2",
  null
  
)

export default component.exports